import React from "react";
import { Box } from "@mui/material";
import PublicFooter from "../modules/public/components/PublicFooter";
import PublicHeader from "../modules/public/components/PublicHeader";
import { brand } from "../modules/public/public.constants";

const AuthLayout = ({ children }) => (
  <Box
    sx={{
      minHeight: "100vh",
      display: "flex",
      flexDirection: "column",
      bgcolor: "#fbfaf5",
      color: brand.ink,
      fontFamily: '"Aptos", "Trebuchet MS", sans-serif',
      background:
        "linear-gradient(135deg, #f8fafc 0%, #eef2ff 52%, #f7fbff 100%)"
    }}
  >
    <PublicHeader variant="minimal" />
    <Box
      component="main"
      sx={{
        flex: 1,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        px: 2,
        py: { xs: 5, md: 6 }
      }}
    >
      {children}
    </Box>
    <PublicFooter />
  </Box>
);

export default AuthLayout;
